import React, { FC } from "react";

import { AdventDoor } from "apps/user/learner/api/types";
import { CATEGORY_ICONS, openedDoors } from "apps/user/learner/lib/advent-doors";
import { useTranslation } from "lib/i18n/use-translation";

import OriButton from "./OriButton";
import styles from "../december-doors.module.scss";

interface RecapLookBackProps {
  door: AdventDoor;
  doors: AdventDoor[];
  isOriEnabled: boolean;
  onChatToOri: (door: AdventDoor) => void;
}

const RecapLookBack: FC<RecapLookBackProps> = ({
  door,
  doors,
  isOriEnabled,
  onChatToOri,
}) => {
  const { t } = useTranslation(["decemberDoors"]);
  const opened = openedDoors(doors);

  return (
    <div className={styles.recap} data-testid="door-recap">
      <h3 className={styles["modal-subheading"]}>
        {t("decemberDoors:recap.title")}
      </h3>
      {opened.length === 0 ? (
        <p className={styles["modal-body-text"]}>
          {t("decemberDoors:recap.empty")}
        </p>
      ) : (
        <>
          <ul className={styles["recap-tiles"]}>
            {opened.map((openedDoor) => {
              const Icon = CATEGORY_ICONS[openedDoor.category];
              return (
                <li
                  key={openedDoor.id}
                  className={styles["recap-tile"]}
                  aria-label={t("decemberDoors:door.a11yOpened", {
                    day: openedDoor.dayNumber,
                    title: openedDoor.title,
                  })}
                >
                  <span className={styles["recap-tile-number"]} aria-hidden>
                    {openedDoor.dayNumber}
                  </span>
                  <Icon className={styles["recap-tile-icon"]} aria-hidden />
                </li>
              );
            })}
          </ul>
          <p className={styles["recap-count"]}>
            {t("decemberDoors:recap.openedCount", { count: opened.length })}
          </p>
        </>
      )}
      {door.closingCopy && (
        <p className={styles["recap-closing"]}>{door.closingCopy}</p>
      )}
      {isOriEnabled && door.oriCtaLabel && door.oriPrompt && (
        <OriButton
          label={door.oriCtaLabel}
          onClick={() => onChatToOri(door)}
          testId="door-cta-ori"
        />
      )}
    </div>
  );
};

export default RecapLookBack;
